var map = {
	"./events-cat-cn.webp": 2016,
	"./events-cat.webp": 2017,
	"./games-cat.webp": 2018,
	"./live-casino-cat-cn.webp": 2019,
	"./live-casino-cat.webp": 2020,
	"./lottery-cat.webp": 2021,
	"./other-cat.webp": 2022,
	"./p2p-cat.webp": 2023,
	"./pd-table.webp": 2024,
	"./privacy-policy-title-bm.webp": 2025,
	"./privacy-policy-title-cn.webp": 2026,
	"./privacy-policy-title-id.webp": 2027,
	"./privacy-policy-title.webp": 2028,
	"./promos-1.webp": 2029,
	"./promos-2.webp": 2030,
	"./promos-3.webp": 2031,
	"./promos-4.webp": 2032,
	"./question.webp": 2033,
	"./sideBar-bg.webp": 2034,
	"./slot-cat-cn.webp": 2035,
	"./slot-cat.webp": 2036,
	"./special-cat-cn.webp": 2037,
	"./special-cat.webp": 2038,
	"./sports-cat-cn.webp": 2039,
	"./sports-cat.webp": 2040
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 483;